import React from "react"
import ReactDOM from "react-dom"
import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import { Dropdown } from "react-bootstrap"
import Overlay from "react-overlays/lib/Overlay"

import {
  sw,
  addAlphaToColor,
  lightenDarkenColor,
  setSiteThemeColor,
  websocketApi
} from "utils"
import App from "./App"
import { setMoment } from "utils/moment"

import fa from "./locales/fa/translation.json"
import en from "./locales/en/translation.json"
import ar from "./locales/ar/translation.json"

import "cropperjs/dist/cropper.css"
import "leaflet/dist/leaflet.css"
import "react-toastify/dist/ReactToastify.css"
import "./index.scss"

const renameUnsafeLifecycles = Component => {
  const prototype = Component?.prototype

  if (prototype?.componentWillMount) {
    prototype.UNSAFE_componentWillMount =
      prototype.componentWillMount

    delete prototype.componentWillMount
  }

  if (prototype?.componentWillReceiveProps) {
    prototype.UNSAFE_componentWillReceiveProps =
      prototype.componentWillReceiveProps

    delete prototype.componentWillReceiveProps
  }
}

renameUnsafeLifecycles(Dropdown)
renameUnsafeLifecycles(Overlay)

i18next
  .use(initReactI18next)
  .init({
    debug: false,
    lng: "fa",
    fallbackLng: "fa",
    resources: {
      fa: { translation: fa },
      en: { translation: en },
      ar: { translation: ar }
    }
  })

i18next.on("languageChanged", (lng) => {
  const fontFamilyLanguageMap = {
    "en": "Roboto, Arial, sans-serif",
    "fa": "yekanX",
    "ar": "yekanX"
  }

  // change website direction
  document.body.style.direction =
    i18next.dir(lng)

  // change website font family
  document.body.style.fontFamily =
    fontFamilyLanguageMap[lng]

  // set time calender
  setMoment(lng)
})

const defaultLanguage =
  localStorage.getItem("defaultLanguage") || "fa"

i18next.changeLanguage(defaultLanguage)

const iframeWindowParentHost =
  window.location.host.split("pos.")[1]

const validateIframeMessage = (event) => {
  if (process.env.NODE_ENV === "production") {
    if (!event.origin.includes("-panel")) return false

    if (!event.origin.includes(iframeWindowParentHost)) return false
  }

  if (event.data.type !== "change-theme-color") return false

  return true
}

// for iframe in panel change theme page
const changeThemeColorForPreview = (event) => {
  if (!validateIframeMessage(event)) return

  const colorsMap = event.data.data

  const keys = Object.keys(colorsMap)

  keys.forEach(key => {
    const mainColor = colorsMap[key]

    const mainColorDark = lightenDarkenColor(mainColor, -45)

    const mainColorAlpha25 = addAlphaToColor(mainColor, 0.25)

    document.querySelector(":root").style.setProperty(`--color-${key}`, mainColor)

    document.querySelector(":root").style.setProperty(`--color-${key}-dark`, mainColorDark)

    document.querySelector(":root").style.setProperty(`--color-${key}-alpha-25`, mainColorAlpha25)
  })
}

window.addEventListener(
  "message",
  changeThemeColorForPreview,
  false
)

setSiteThemeColor()

const rootElement = document.getElementById("root")

ReactDOM.render(<App />, rootElement)

window.location.pathname !== "/cds-checkout" &&
  websocketApi.createConnection()

sw.registerServiceWorker()
